export enum IssueStatusType {
  NEW = 'NEW',
  ASSIGNED = 'ASSIGNED',
  RESOLVED = 'RESOLVED',
  ASSIGNED_TO_ME = 'ASSIGNED_TO_ME',
}
